export  enum RoleType {
    Root = 1,
    ChiefEngineer = 2,
    SeniorEngineer =3,
    SuperAdmin = 4,
    SuperintendEngineer = 5,
    ExecutiveEngineer = 6,
    AssistantExecutiveEngineer = 7,
    AssistantEngineer = 8,
    Foreman = 9,
    WSAE = 10,
    WSAEE = 11,
    Farmer = 12,
    HOOfficial = 13, 
    AEAllocationEngineer = 14,
    APC = 15,
    HOFinance = 16
}


